// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.clearfix[data-v-0ea88f00]{\n  font-family: PingFang SC;\n  font-weight: bold;\n  font-size: 16px;\n  color: #1C1C1C;\n  line-height: 22px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack:justify;\n      -ms-flex-pack:justify;\n          justify-content:space-between;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
